<div class="row row-cols-1 m-auto justify-content-md-center mt-3" [class.w-75]="!isMobile()" [class.w-100]="isMobile()">
    <div class="col-12">
        <div class="my-4">
            @if (embedded()) {
            <!-- Inside the signup onboarding: this customer never saw the old checkout,
                 so the step explains how ordering works instead of announcing a change. -->
            <p class="text-center fst-italic h5-regular">Shopping with us is simple.</p>
            <p class="text-justify">
                There is <strong>no checkout step</strong>.
                Your order is <strong>automatically finalized</strong>
                and scheduled for delivery after the cut-off time.
            </p>
            } @else {
            <p class="text-center fst-italic h5-regular">We’ve simplified your shopping experience!</p>
            <p class="text-justify">
                There is <strong>no longer a checkout step</strong>.
                Your order is <strong>automatically finalized</strong>
                and scheduled for delivery after the cut-off time.
            </p>
            }
            <p class="text-justify">
                <strong>
                    If you do not want to receive an order, make sure to skip it before the cut-off time.
                </strong>
            </p>
            <p class="text-justify">You can do this from your cart or subscription settings.</p>

            <hr>

            <p class="text-center">
                <i class="text-black-50">
                    Note: This message will be displayed again until you accept {{ embedded() ? 'it' : 'the changes' }}.
                </i>
            </p>

        </div>
    </div>
</div>

<!-- Enable button when countdown reaches 0 -->
<div class="d-grid gap-2 col-6 col-lg-6 col-md-12 col-sm-12 mx-auto mt-2">
    <button [disabled]="countdown() > 0" (click)="acceptCheckoutChange()"
        class="btn btn-primary d-flex gap-2 align-items-center justify-content-center">
        I Understand {{ countdown() > 0 ? '(' + countdown() + ')' : '' }}
    </button>
</div>